<template>
  <div>
    <div class="d-lg-none">
      <div class="row">
        <div class="col-12 col-sm-6" v-for="r in resources.data" :key="'mobile-' + r.id">
          <bs-card class="card-info mt-2" :label="''">
            <template v-slot:header>
            </template>
            <div class="p-2">
              <small><b>{{ r.created_at | luxon }}</b> <span class="text-muted">{{ r.created_at | luxon:diffForHumans }}</span></small><br>
              <div class="d-flex justify-content-between">
                <div>{{ find(feeds, 'id', r.feed_id, 'label') }}</div>
                <div><b>{{ $n(r.amount, 'currency') }}</b></div>
              </div>
              <div class="pt-2">{{ r.description }}</div>
            </div>
            <template v-slot:footer>
              <div class="py-1 px-2 d-flex justify-content-between">
                <div>
                  <span v-if="r.transaction">
                    <span v-if="r.transaction.budget_id" class="badge badge-pill badge-warning">{{ find(budgets, 'id', r.transaction.budget_id, 'label') }}</span>
                    <span v-else class="badge badge-pill badge-primary">{{ find(funds, 'id', r.transaction.fund_id, 'label') }}</span>
                    <span v-for="tag in r.tags" :key="'r' + r.id + 't' + tag.id" :class="'badge badge-pill bg-' + tag.color">{{ tag.label }}</span>
                  </span>
                </div>
                <div>
                  <bs-action v-if="r.transaction" :icon="['fal', 'check']" class="btn-success"></bs-action>
                  <bs-action v-else :icon="['fal', 'plus']" :tip="labels.edit" class="btn-info" @click="update(r)"></bs-action>
                </div>
              </div>
            </template>
          </bs-card>
        </div>
      </div>
    </div>
    <bs-card class="card-info d-none d-lg-block" :icon="icon" :label="labels.name">
      <template v-slot:header>
        <bs-button class="btn-sm btn-info" @click="importFile">{{ $t('labels.import') }}</bs-button>
      </template>
      <bs-table v-bind="{dataLength, loading}" :cols="7">
        <template v-slot:thead>
          <tr v-if="resourceState.search.active">
            <th class="p-1" colspan="6">
              <input type="text" class="form-control form-control-sm border-1 border-primary shadow-sm bg-light" v-model="searchPhrase">
            </th>
            <th class="text-right"><bs-action :icon="['fas', 'times']" class="btn-outline-secondary" @click="applySearch({active: false, phrase: ''})"></bs-action></th>
          </tr>
          <tr v-else>
            <th scope="col">{{ $tc('labels.feed', 1) }}</th>
            <th scope="col">{{ $t('labels.description') }}</th>
            <th scope="col">{{ $t('labels.amount') }}</th>
            <th scope="col">{{ $tc('labels.budget', 1) }} / {{ $tc('labels.fund', 1) }}</th>
            <th scope="col">{{ $tc('labels.tag', 0) }}</th>
            <th scope="col" class="text-right">{{ $t('labels.date') }}</th>
            <th class="text-right"><bs-action :icon="['fal', 'search']" class="btn-outline-secondary" @click="applySearch({active: true, phrase: ''})"></bs-action></th>
          </tr>
        </template>
        <tr v-for="r in resources.data" :key="r.id">
          <td>{{ find(feeds, 'id', r.feed_id, 'label') }}</td>
          <td>{{ r.description }}</td>
          <td>{{ $n(r.amount, 'currency') }}</td>
          <td>
            <span v-if="r.transaction">
              <span v-if="r.transaction.budget_id" class="badge badge-pill badge-warning">{{ find(budgets, 'id', r.transaction.budget_id, 'label') }}</span>
              <span v-else class="badge badge-pill badge-primary">{{ find(funds, 'id', r.transaction.fund_id, 'label') }}</span>
            </span>
          </td>
          <td>
            <span v-if="r.transaction">
              <span v-for="tag in r.tags" :key="'r' + r.id + 't' + tag.id" :class="'badge badge-pill bg-' + tag.color">{{ tag.label }}</span>
            </span>
          </td>
          <td class="text-right">{{ r.created_at | luxon }}</td>
          <td class="t2">
            <bs-action :icon="['fal', 'trash']" :tip="labels.delete" class="btn-danger" @click="destroy(r)"></bs-action>
            <bs-action v-if="r.transaction" :icon="['fal', 'check']" class="btn-success"></bs-action>
            <bs-action v-else :icon="['fal', 'plus']" :tip="labels.edit" class="btn-info" @click="update(r)"></bs-action>
          </td>
        </tr>
      </bs-table>
    </bs-card>
    <bs-modal :name="'create-' + $options.name" :label="resource.id ? labels.edit : labels.create">
      <bs-form :submit="$t('labels.submit')" @submit="submit">
        <template v-slot:default="slotProps">
          <input-field :name="'description'" :label="$t('labels.description')" v-model="resource.description" :error="slotProps.error"></input-field>
          <select-field v-if="!resource.fund_id" :name="'budget'" :label="$tc('labels.budget', 1)" v-model="resource.budget_id" :error="slotProps.error">
            <option :value="0"></option>
            <option v-for="budget in budgets" :key="'b' + budget.id" :value="budget.id">{{ budget.label }}</option>
          </select-field>
          <select-field v-if="!resource.budget_id" :name="'fund'" :label="$tc('labels.fund', 1)" v-model="resource.fund_id" :error="slotProps.error">
            <option :value="0"></option>
            <option v-for="fund in funds" :key="'f' + fund.id" :value="fund.id">{{ fund.label }}</option>
          </select-field>
          <div class="form-group bs-form-group">
            <label class="typo__label text-uppercase">{{ $tc('labels.tag', {}, 0) }}</label>
            <multiselect v-model="resource.tags"
                         :options="tags"
                         :multiple="true"
                         :close-on-select="false"
                         :clear-on-select="false"
                         :preserve-search="true"
                         :showLabels="false"
                         label="label"
                         :placeholder="$t('labels.please_select')"
                         track-by="id">
            </multiselect>
          </div>
        </template>
      </bs-form>
    </bs-modal>
    <bs-modal :name="'import-' + $options.name" :label="$t('labels.import')">
      <bs-form :submit="$t('labels.submit')" @submit="submitFile">
        <template v-slot:default="slotProps">
          <select-field :name="'feed_id'" :label="$tc('labels.bank_feed', 1)" v-model="feedImport.feed_id" :error="slotProps.error">
            <option v-for="feed in feeds" :key="'f' + feed.id" :value="feed.id">{{ feed.label }}</option>
          </select-field>
          <file-field :name="'file'" :label="$t('labels.file')" v-model="feedImport.file" :error="slotProps.error" />
        </template>
      </bs-form>
    </bs-modal>
    <bs-modal :name="'destroy-' + $options.name" :label="labels.delete">
      <bs-form :destroy="$t('labels.destroy')" @submit="destruction">
        {{ $t('messages.delete', { resource: 'transaction' }) }}
      </bs-form>
    </bs-modal>
    <portal to="app-footer">
      <pagination :data="resources" :state="resourceState" @pushPage="index"></pagination>
    </portal>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { resourceControl } from '../../mixins/resourceControl'
import Multiselect from 'vue-multiselect'

export default {
  name: 'BankFeeds',
  mixins: [resourceControl],
  components: {
    Multiselect
  },
  data () {
    return {
      icon: ['fal', 'funnel-dollar'],
      resource: {
        description: '',
        budget_id: null,
        fund_id: null,
        tags: {}
      },
      feedImport: {
        feed_id: null,
        file: null
      },
      labels: {
        delete: this.$t('labels.action_resource', { action: this.$t('labels.delete'), resource: this.$tc('labels.transaction', 1) }),
        edit: this.$t('labels.action_resource', { action: this.$t('labels.create'), resource: this.$tc('labels.transaction', 1) })
      }
    }
  },
  computed: {
    ...mapState({
      resources: state => state.bankFeeds,
      resourceState: state => state.bankFeedsState,
      feeds: state => state.feedsStore,
      budgets: state => state.budgetsStore,
      funds: state => state.fundsStore,
      tags: state => state.tagsStore
    })
  },
  methods: {
    importFile () {
      this.$store.commit('axiosError', null)
      this.feedImport = {
        feed_id: null,
        file: null
      }
      this.$modal.show('import-' + this.$options.name)
    },
    submitFile () {
      this.$store.dispatch('chunk', {
        url: '/api/bank-feeds/import',
        resource: this.feedImport,
        icon: ['fal', 'user'],
        message: this.$t('messages.simple_loading', { resource: 'file' }),
        callback: () => { this.index() }
      }).then(() => {
        this.$modal.hide('import-' + this.$options.name)
      })
    }
  }
}
</script>
